import React, { useState } from "react";
import { Modal, Form } from "react-bootstrap";
import { useDispatch,useSelector } from "react-redux";
import { useSnackbar } from "react-simple-snackbar";
import { updateUserPassword } from "../../../redux/actions/UserAction";

function ProfileModal(props) {
  // updateUserPassword
  const dispatch = useDispatch();
  const [openSnackbar, closeSnackbar] = useSnackbar();
  const [originalPassword, setOriginalPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [conformPassword, setConformPassword] = useState("");
  const [loder, setLoder] = useState(false);

  const User = useSelector((state) => state.UserReducer.user);

  const resetPassword = (e) => {
    e.preventDefault();
    setLoder(true);
    if (!newPassword || !conformPassword || !originalPassword) {
      setLoder(false);
      openSnackbar("Please fill all the fields");
    } else if (newPassword !== conformPassword) {
      setLoder(false);
      openSnackbar("Password does not match.");
    } else {
      const data = {
        phoneNumber: User.phoneNumber,
        oldpassword: originalPassword,
        newpassword: newPassword,
      };
      const onSuccess = () => {
        setLoder(false);
        setOriginalPassword("")
        setConformPassword("")
        setNewPassword("")
        props.onHide()
        openSnackbar("Password updated successfully.");
      };
      const onError = (message) => {
        setLoder(false);
        props.onHide()
        openSnackbar(message);
      };
      dispatch(updateUserPassword(data, onSuccess, onError));
    }
  };

  return (
    <div>
      <Modal
        {...props}
        size="md"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        className="pass"
      >
        <Modal.Body>
          <h4>Change Password</h4>
          <Form onSubmit={(e) => resetPassword(e)}>
            <Form.Group controlId="formBasicPassword">
              <Form.Label className="text">Original Password</Form.Label>
              <Form.Control
                className="input"
                id="opass"
                type="password"
                placeholder="Password"
                value={originalPassword}
                onChange={(e) => setOriginalPassword(e.target.value)}
                required
              />
              <Form.Label className="text">New Password</Form.Label>
              <Form.Control
                className="input"
                id="npass"
                type="password"
                placeholder="Enter new password"
                value={newPassword}
                onChange={(e) => setNewPassword(e.target.value)}
                required
              />
              <Form.Label className="text">Confirm Password</Form.Label>
              <Form.Control
                className="input"
                id="cpass"
                type="password"
                placeholder="Confirm new password"
                value={conformPassword}
                onChange={(e) => setConformPassword(e.target.value)}
                required
              />
            </Form.Group>

            <button id="changepasssubmit" type="submit" disabled={loder}> {loder?"Updating..":"Submit"} </button>
          </Form>
        </Modal.Body>
      </Modal>
    </div>
  );
}

export default ProfileModal;
